import { AND, OR, NOT } from 'utils/combinatorTypes';

export const COMBINATOR_TEST_ID = 'entry-rules-combinator-select';
export const FILTERS_TEST_ID = 'entry-rules-filters';

export const COMBINATOR_TEXT = {
  [AND]: { conjunction: 'and', name: 'All', value: AND },
  [OR]: { conjunction: 'or', name: 'Any', value: OR },
  [NOT]: { conjunction: 'nor', name: 'None', value: NOT },
};

export const FILTERS_DISPLAY_TEXT = {
  addText: 'Add additional entry rule',
};
